import { render, staticRenderFns } from "./AcceptForm.vue?vue&type=template&id=196df5da&scoped=true&"
import script from "./AcceptForm.vue?vue&type=script&lang=js&"
export * from "./AcceptForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196df5da",
  null
  
)

export default component.exports